export default {
    confirm: 'Yes, leave now',
    content: 'You can only join the work space again, if another participant invites you.',
    title: 'Are you sure you want to leave the work space "{title}" ?',
    success: 'You left the work space successfully.'
}
